export default __webpack_public_path__ + "static/media/Vector-1.0a356df3.svg";